import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/auth'
import 'firebase/analytics'

const firebaseConfig = {
  apiKey: "AIzaSyBXEEgHCJbfZT5DVLg-qQ17UeK_TIi-NZY",
  authDomain: "moa-22.firebaseapp.com",
  databaseURL: "https://moa-22-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "moa-22",
  storageBucket: "moa-22.appspot.com",
  messagingSenderId: "633301064433",
  appId: "1:633301064433:web:0781716d57c35172912750"
}

firebase.initializeApp(firebaseConfig)
firebase.analytics()

const firebaseDb = firebase.database()
const firebaseAuth = firebase.auth()

const getDbRef = (dbRef) => {
  const envDbRef = `${process.env.NODE_ENV === 'production' ? 'production' : 'local'}/${dbRef}`
  return firebaseDb.ref(envDbRef)
}

const ChatDb = getDbRef('chat')
const QRcodeDb = getDbRef('QRcode')
const NoticeDb = getDbRef('notice')
const NotificationDb = getDbRef('pushNotifications')

const getHallQuestionDb = (sid) => getDbRef(`hallQuestion/${sid}`)
const getHallChatDb = (sid) => getDbRef(`hallChat/${sid}`)

const getUniqueSessionDb = (uid) => getDbRef(`uniqueSession/${uid}`)
const getUserCountDb = (uid, path) => getDbRef(`userCount/${path}/${uid}`)
const getUserSessionDb = (uid) => getDbRef(`userSessions/${uid}`)
const getOnlineStatusDb = (uid) => getDbRef(`onlineStatus/${uid}`)
const getLiveCheckInSessionDb = (hallNumber) => getDbRef(`liveCheckInSession/hall-${hallNumber}`)
const getLiveSessionDb = (hallNumber) => getDbRef(`liveSession/${hallNumber}`)
const getRefreshDb = (uid) => getDbRef(`shouldRefresh/${uid}`)

export {
  firebaseDb,
  firebaseAuth,
  ChatDb,
  QRcodeDb,
  NoticeDb,
  NotificationDb,
  getHallQuestionDb,
  getHallChatDb,
  getLiveSessionDb,
  getUniqueSessionDb,
  getUserCountDb,
  getUserSessionDb,
  getOnlineStatusDb,
  getLiveCheckInSessionDb,
  getRefreshDb,
}
